/**
 * 连接数组/类数组，通常在代理函数时用来扩展参数
 * (argsArr, args1, args2, args3...) => argsArr.concat([args1, args2, args3...])
 */
export default () => {
  let args = Array.from(arguments)
  let arr = Array.from(args.shift())
  return arr.concat(args)
}



// WEBPACK FOOTER //
// ./src/packages/utils/src/concatArgs.js